<template>
  <span class="v-icon default-icon"></span>
</template>
<style scoped>
.default-icon::before {
  content: '\24D3';
  font-weight: bold;
}
.default-icon {
  display: inline-block;
}
</style>
